import { useEffect, useState } from "react";
import Footer from "../components/main/Footer";
import { BrowserRouter, Routes, Route, Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import Title from "../components/main/Title";
import TopMenu from "../components/main/TopMenu";
import PricePolicyScreen from "./PricePolicyScreen";
import SupportScreen from "./SupportScreen";
import PublicMapScreen from "./PublicMapScreen";
import ContactUs from "./ContactUs";
import HomeScreen from "./HomeScreen";
import CreateMapScreen from "./CreateMapScreen";
import UserGuideScreen from "./UserGuideScreen";
import CompanyInfoScreen from "./CompanyInfoScreen";
import MapScreen from "./MapScreen";
import MyPageScreen from "./MyPageScreen";
import SignUpScreen from "./SignUpScreen";
import SignUpAddInfoScreen from "./SignUpAddInfoScreen";
import FindAccountScreen from "./FindAccountScreen";
import KakaoLoginScreen from "./KakaoLoginScreen";
import NaverLoginScreen from "./NaverLoginScreen";
import GoogleLoginScreen from "./GoogleLoginScreen";
import FacebookLoginScreen from "./FacebookLoginScreen";
import { path } from "../components/common/Common";
import DataProvider from "../data_provider/DataProvider";
import { LoginQueryParams } from "../data_provider/gateways/SessionGateway ";

// 💠 25.03.20.THU | YoungJun | NotFoundScreen 컴포넌트 추가
import NotFoundScreen from "../screens/NotFoundScreen";
import PasswordForm, { PasswordFormType } from "../components/mypage/PasswordForm";
import TermsScreen from "./TermsScreen";
import { HelmetProvider } from "react-helmet-async";

// 25.08.18 라우드 대응 gtag 컴포넌트
import GtagPageViewTracker from "../module/analytics/GtagPageViewTracker";
import ScrollToTop from "../components/common/ScrollToTop";
import { emitAuthEvent } from "../module/auth";
import PrivacyScreen from "./PrivacyScreen";
import MobileMapScreen from "./MobileMapScreen";

function Main(props: any) {
    const [isMap, setIsMap] = useState(false);
    const [isNotFound, setIsNotFound] = useState(false);
    const [isSocialLogin, setIsLogin] = useState(false);

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const fetchMapCountStub = async () => {
        const response = await DataProvider.GetMapCountData();
        return response.flag ? response.result : undefined;
    };

    // 백엔드 로그인 연결 전 테스트 함수로 사용하지 않으므로 주석처리 함 | 250905 | smyun
    // const loginStub = async () => {
    //     const userInfo: LoginQueryParams = {
    //         id: "moamap@ksic.net",
    //         password: "devlab#1226",
    //         platform: "LOCAL",
    //     };

    //     DataProvider.Login(userInfo).then((response) => {
    //         if (response.flag) {
    //             // KMLN은 프론트에서 추가/변경하는 쿠키, 로그인 여부 판별용
    //             setCookie("KMLN", 1);
    //         }
    //     });
    // };

    const logoutStub = async () => {
        await DataProvider.Logout();
        emitAuthEvent("logout"); // 로그아웃 시 모든 탭에 알림

        // 미완료된 소셜 회원가입 정보 정리
        localStorage.removeItem("authJson");
    };

    const mainStub = () => {};

    // 비로그인 상태에서의 [아이디/비밀번호찾기] 비밀번호 변경 중 취소 버튼 클릭 시 | 250902 | smyun
    const onDismiss = () => {
        // 홈으로 이동 + 히스토리 남기지 않게 기록 교체 replace 처리
        window.location.replace(path.ROOT);
    };

    return (
        <HelmetProvider>
            {/* <BrowserRouter> */}
            <BrowserRouter basename="/">
                {/* 페이지 이동 시 스크롤 처리 */}
                <ScrollToTop />

                {/* GA4 page_view 추적 -> (라우트 변경 시마다 전송) */}
                <GtagPageViewTracker />

                {/*  mount 후에만 Title과 TopMenu 렌더 */}
                {mounted && !isMap && !isNotFound && !isSocialLogin && (
                    <>
                        {!isMap && !isNotFound && !isSocialLogin && <Title mapCount={fetchMapCountStub} logout={logoutStub} />}
                        {!isMap && !isNotFound && !isSocialLogin && <TopMenu />}
                    </>
                )}

                <Routes>
                    <Route path={path.ROOT} element={<HomeScreen mapCount={fetchMapCountStub} />}></Route>
                    <Route path={path.CREATE_MAP} element={<CreateMapScreen />}></Route>
                    <Route path={path.GUIDE} element={<UserGuideScreen />}></Route>
                    <Route path={path.PRICE_POLICY} element={<PricePolicyScreen />}></Route>
                    <Route path={path.SUPPORT} element={<SupportScreen />}></Route>
                    <Route path={path.PUBLIC_MAPLIST} element={<PublicMapScreen />}></Route>
                    {/* <Route path={path.CONTACT} element={<ContactUs onSubmit={sendMailStub} />}></Route> */}
                    <Route path={path.CONTACT} element={<ContactUs />}></Route>
                    <Route path={path.COMPANY_INFO} element={<CompanyInfoScreen />}></Route>
                    <Route path={path.TERMS} element={<TermsScreen />}></Route>
                    <Route path={path.PRIVACY} element={<PrivacyScreen />}></Route>
                    <Route path={path.MAP} element={<MapScreen setIsMap={setIsMap} />}></Route>
                    <Route path={path.MOBILE_MAP} element={<MobileMapScreen setIsMap={setIsMap} />}></Route>
                    <Route path={`${path.MYPAGE}/:tab`} element={<MyPageScreen />}></Route>
                    <Route path={path.SIGNUP} element={<SignUpScreen />}></Route>
                    <Route path={path.SIGNUP_ADD_INFO} element={<SignUpAddInfoScreen />}></Route>
                    <Route path={path.FIND_ACCOUNT} element={<FindAccountScreen />}></Route>
                    <Route path={path.PORTAL_LOGIN_KAKAO} element={<KakaoLoginScreen setIsLogin={setIsLogin} />}></Route>
                    <Route path={path.PORTAL_LOGIN_NAVER} element={<NaverLoginScreen setIsLogin={setIsLogin} />}></Route>
                    <Route path={path.PORTAL_LOGIN_GOOGLE} element={<GoogleLoginScreen setIsLogin={setIsLogin} />}></Route>
                    <Route path={path.PORTAL_LOGIN_FACEBOOK} element={<FacebookLoginScreen setIsLogin={setIsLogin} />}></Route>

                    {/* 비밀번호 변경 페이지 라우트 추가 */}
                    <Route
                        path={path.PASSWORD_CHANGE}
                        element={
                            <PasswordForm
                                data={{
                                    userId: "",
                                    username: "",
                                    emailNotification: 1,
                                }}
                                title="비밀번호 변경"
                                onSubmit={async (data) => {
                                    return { flag: true, status: 200, result: {} };
                                }}
                                onDismiss={onDismiss}
                                mode={PasswordFormType.Reset}
                            />
                        }
                    />

                    <Route path="*" element={<NotFoundScreen setIsNotFound={setIsNotFound} />}></Route>
                </Routes>

                {!isMap && !isNotFound && !isSocialLogin && <Footer />}
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default Main;
